import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ProfileInfo.style';

const ProfileInformation = () => {
  const { obo } = useAuthentication();
  const {
    email = '', firstName = '', lastName = '', accountEmail = ''
  } = useIdentity();
  const isObo = !!obo;
  const profileEmail = isObo ? email : accountEmail;
  const profileName = `${firstName} ${lastName}`;

  return (
    <Styled.Root className="profile-info">
      <Text
        weight="medium"
        size="xl"
      >
        <Text truncate>
          {isObo ? `On behalf of ${profileName}` : profileName}
        </Text>
      </Text>
      <Text truncate size="sm">{profileEmail}</Text>
    </Styled.Root>
  );
};

export default ProfileInformation;
